export default () => ({
  bays: [],
  bay: null,
  slots: [],
  defaultBay: {
    bay: null,
    firm: null,
    bayName: '',
    startOfDay: '08:00',
    endOfDay: '17:00',
    isInactive: false,
    technician: null,
    slots: 0,
    avgSlotTime: 0,
    blocks: []
  },
  selectedSlot: null
})



// WEBPACK FOOTER //
// ./src/store/modules/bays/state.js